// Review & Post (shell) -> Data Entry hand-off: the planned row to edit travels through sessionStorage because the shell mounts the two pages as separate routes (classic App passes it as a prop).
// READ WITHOUT DELETING (React StrictMode double-runs initialisers and the shell can remount the page while it loads: a read-once hand-off would lose the row); it is cleared a few seconds after the page has mounted, and a hand-off older than 20 s is ignored so a later visit never opens in edit mode by surprise.
export const PENDING_EDIT_KEY = 'de.pendingEdit';
export const PENDING_EDIT_MAX_AGE_MS = 20000;
export function stashPendingEdit(storage, row, now = Date.now()) {
  try { storage.setItem(PENDING_EDIT_KEY, JSON.stringify({ at: now, row })); return true; } catch { return false; }
}
export function peekPendingEdit(storage, now = Date.now()) {
  try {
    const raw = storage.getItem(PENDING_EDIT_KEY); if (raw == null) return null;
    const v = JSON.parse(raw);
    if (!v || typeof v !== 'object' || !v.row || typeof v.row !== 'object' || !v.row.id || !v.row.type) return null;
    return now - Number(v.at) <= PENDING_EDIT_MAX_AGE_MS ? v.row : null;
  } catch { return null; }
}
export function clearPendingEdit(storage) { try { storage.removeItem(PENDING_EDIT_KEY); } catch { /* storage unavailable */ } }
